import { z } from "zod";
import { BaseConfigurationsOutputItemSchema } from "@/Schemas/Configurations/BaseConfigurationsOutputItem";

export const ConfigurationsRecordOutputSchema = z.object({
    items: z.array(BaseConfigurationsOutputItemSchema),
});

export type ConfigurationsRecordOutput = z.infer<typeof ConfigurationsRecordOutputSchema>;